export const REPLAY_COPY = {
  button: "Play again",
  loading: "Setting up your game…",
  existing: "Go to your new game",
  lobbySubtitle: "Your lobby is ready",
  error: "Couldn't start a new game. Please try again.",
  backHome: "Back home",
};

export const INVITE_COPY = {
  hint: (host) => `${host} can ask everyone to play again.`,
  title: (host) => `${host} wants to play again.`,
  message: "Join the new game?",
  accept: "Join",
  decline: "Not now",
  loading: "Joining game…",
  error: "Couldn't join the new game. Please try again.",
  started: (host) => `This game has already started. Ask ${host} to invite you next time.`,
};

export const LIMIT_COPY = {
  title: "Ready for more?",
  body: "You've hosted your 3 free games. You can host again in:",
  countdownLabel: "Until your free games reset",
  getCoins: "Get more coins",
  later: "Maybe later",
  hostNow: (cost) => `Host now for ${cost} coins`,
  hostNowLoading: "Starting your game…",
  hostNowError: "Couldn't start your game. Please try again.",
};

export const PRO_OFFER_COPY = {
  title: "Want to host without limits?",
  body: "Get Pro and host unlimited games.",
  button: "Get Pro",
};

export const WELCOME_COPY = "Welcome to NameIt! 🎉 You've received 150 coins to get started. Have fun playing!";

export const SIGNUP_NUDGE_COPY = {
  title: "Get 150 free coins",
  body: "Sign up and we'll add 150 coins to your account.",
  button: "Sign up",
  later: "Maybe later",
};

export function waitingForPlayers(names) {
  const list = (names || []).filter(Boolean);
  if (list.length === 0) return "";
  if (list.length === 1) return `Waiting for ${list[0]} to join.`;
  if (list.length === 2) return `Waiting for ${list[0]} and ${list[1]} to join.`;
  const others = list.length - 2;
  return `Waiting for ${list[0]}, ${list[1]}, and ${others} ${others === 1 ? "other" : "others"} to join.`;
}

export function formatCountdown(ms) {
  const totalSeconds = Math.max(0, Math.ceil(ms / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  if (hours > 0) return `${hours}h ${String(minutes).padStart(2, "0")}m ${String(seconds).padStart(2, "0")}s`;
  if (minutes > 0) return `${minutes}m ${String(seconds).padStart(2, "0")}s`;
  return `${seconds}s`;
}
